// Array
export const LANGUAGES = ['en', 'it', 'es'];

// Available lesson filters — keywords in EN / IT / ES
export const LESSON_TYPE_FILTER_KEYWORDS: Record<string, string[]> = {
  discussion_forum: ['discussion forum', 'forum di discussione', 'foro de discusión'],
  midterm_exam: ['midterm exam', 'esame intermedio', 'examen parcial'],
  final_exam: ['final exam', 'esame finale', 'examen final'],
  lesson: ['lesson', 'lezione', 'lección'],
};

// String
export const EMPTY_STRING = '';
export const GENERATE_AVATAR_BASE_URL = 'https://ui-avatars.com/api/';
export const INVALID_VALUE = 'Invalid';
export const TIME_DEFAULT_LABEL = '00:00:00';
export const ENGLISH_VIDEO_LESSON_SUBTITLE = 'ENG';
export const ITALIAN_VIDEO_LESSON_SUBTITLE = 'ITA';
export const SELECTION_OPTION_ID = 'SELECT_EMPTY';

// Number
export const DEFAULT_NUMBER_ONE = 1;
export const DEFAULT_NUMBER_ZERO = 0;
export const TIMEOUT_ALERT_MILLISECOND = 3000;
export const DEFAULT_LIMIT = 1000;
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT_PAGE = 20;
export const MAX_VIDEO_TIME_FORWARD = 2;
export const TIMEOUT_REFRESH_DISCUSSION = 500;
export const TIME_CLOSE_TOAST = 4000;
export const TIME_OUT_SHOW_TOAST = 1000;
export const TIME_OUT_SHOW_TOAST_ERROR = 200;
export const TIME_OUT_SHOW_TOAST_SUCCESS = 1000;
export const SECOND_PER_LIMIT = 60;
export const MILLISECOND_PER_SECOND = 1000;
export const TIMEOUT_RE_ANSWER_QUESTION = 2000;
export const LAST_SECONDS_TO_MARK_WATCHED = 180;
export const PROGRESS_POST_INTERVAL_MS = 10000;
export const DISCUSSION_EXPORT_POLL_INTERVAL_MS = 4000;
export const DISCUSSION_EXPORT_POLL_MAX_INTERVAL_MS = 30000;
export const DISCUSSION_EXPORT_MAX_LISTED_WARNINGS = 10;
// "Another export is running" needs more time to read than the default toast
export const DISCUSSION_EXPORT_NOTICE_MS = 10000;
// The quiz answers PDF of one student takes seconds: poll often (less while queued behind another PDF)
export const QUIZ_ANSWERS_EXPORT_POLL_INTERVAL_MS = 2000;
export const QUIZ_ANSWERS_EXPORT_QUEUED_POLL_INTERVAL_MS = 5000;
export const QUIZ_ANSWERS_EXPORT_POLL_MAX_INTERVAL_MS = 15000;

// Backend codes shown with their own message instead of the generic error toast
export const CANVAS_SESSION_EXPIRED_CODE = 60004; // the Canvas authorization can't be renewed: new login
export const COURSE_PENDING_ACTIVATION_CODE = 80003; // only "invited" enrollments, activated within ~15 min
export const COURSE_NOT_ENROLLED_CODE = 80004; // no course at all
export const CANVAS_SESSION_EXPIRED_EVENT = 'canvas-session-expired';
// Message (namespace common/home) of the lesson cards for the codes above
export const COURSE_ACTIVATION_MESSAGE_KEYS: Record<number, string> = {
  [COURSE_PENDING_ACTIVATION_CODE]: 'lesson_pending_activation_message',
  [COURSE_NOT_ENROLLED_CODE]: 'lesson_not_enrolled_message',
};
// Materials archive: the backend answers within ~20 s and keeps loading the rest, so a partial
// answer (isComplete false) is asked again a few times.
export const MATERIAL_ARCHIVE_RETRY_DELAY_MS = 5000;
export const MATERIAL_ARCHIVE_MAX_AUTO_RETRIES = 3;

// Regex
export const REG_EXP = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  QUERY: /%20/g,
};

// Components

// Date
export const DATE_FORMAT = {
  DATE: 'MM/DD/YYYY',
  LONG_FORMAT: 'MMMM D, YYYY',
  TIME: 'hh:mm A',
  PDF_DATE: 'hh:mm A MM/DD/YYYY',
};
